import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import env from '../../../../../util/env';
import {labels} from '../../../../../util/utils';
import {IconoirNetwork} from '@ey-xd/motif-icon';
import {serviceURL, routeToRedirectEditProject} from '../../../../../util/uiconstants';

import selectAllClients from '../../../../../reducers/Clients/selectors/selectAllClients';
import {getAllClients} from '../../../../../actions/Clients/clientsaction';
import {getAllAccessgroups} from '../../../../../actions/AccessGroups/Accessgroupactions';
import {setEditMode} from '../../../../../actions/EditProject/editprojectactions';
import getNodesFromProject from './getNodesFromProject';

import OutputText from '@ey/canvascoreservices/OutputText';
import Tooltip from '../../../../CoreWrappers/Tooltip';
import StyledOrgChartEntityEdit from './StyledOrgChartEntityEdit';
import HrAlt from '../../../Hr/HrAlt';
import Button from '../../../../CoreWrappers/Button';

const OrgChartRedirect = ({projectId}) => {
	let accessGroupsSaved = useSelector((state) => state.accessGroups);
	const project = useSelector((store) => store.project);
	const clients = useSelector(selectAllClients);

	const history = useHistory();
	const dispatch = useDispatch();

	const handlerOnClick = () => {
		if (accessGroupsSaved.length === 0) {
			dispatch(getAllAccessgroups(projectId));
		}
		if (clients?.length === 0) {
			let url = `${env.getBaseURL(serviceURL)}Clients`;
			dispatch(getAllClients());
		}
		const actualUrl = window.location.href;
		let urlRedirect;
		if (actualUrl.indexOf(routeToRedirectEditProject.contactsUrl) >= 0) {
			urlRedirect = routeToRedirectEditProject.contacts;
		} else {
			urlRedirect = routeToRedirectEditProject.dashbaord;
		}

		const nodes = getNodesFromProject(project.orgStructure);
		const url = routeToRedirectEditProject.editProject.replace('{projectId}', projectId);
		dispatch(setEditMode(true, urlRedirect + projectId, nodes, null)).then(() => {
			history.push(url, null);
		});
	};

	const renderTrigger = () => {
		const props = {
			svg: IconoirNetwork,
			label: labels.organizationalChart,
			onClick: () => handlerOnClick(),
			variant: 'ghost'
		};

		return <Button {...props} />;
	};

	const props = {
		trigger: renderTrigger(),
		allowClick: true
	};

	return (
		<StyledOrgChartEntityEdit className="sidebar-footer">
			<HrAlt />
			<Tooltip {...props}>
				<OutputText>{labels.organizationalChartTooltip}</OutputText>
			</Tooltip>
		</StyledOrgChartEntityEdit>
	);
};
OrgChartRedirect.propTypes = {projectId: PropTypes.string};

export default OrgChartRedirect;
